import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listVehiclesInspectedService } from "../sevices/listVehiclesInspected.service.js";

export const useVehiclesInspectedQuery = (filters) => {
  const fetchData = useFetch();
  const [vehiclesInspected, setVehiclesInspected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchVehiclesInspected = async () => {
      try {
        console.log(filters);
        setLoading(true);
        const response = await listVehiclesInspectedService(fetchData)({
          filters,
        });
        setVehiclesInspected(response.data);
      } catch (error) {
        throw error;
      } finally {
        setLoading(false);
      }
    };

    const debounced = debounce(fetchVehiclesInspected, 500);
    debounced();
    return () => {
      debounced.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters]);

  return {
    vehiclesInspected,
    loading,
    refresh: () => setRefresh((prev) => !prev),
  };
};
